module.exports = __webpack_public_path__ + "static/media/foglia_ficus.b8eca448.svg";